import React from "react";
import * as D from "./Farms.desktop.styled";

const FarmCardDesktopSkeleton = () => (
  <D.SkeletonCard data-testid="farm-skeleton" aria-hidden="true">
    <D.SkeletonMedia />
    <D.SkeletonBody>
      <D.SkeletonTagRow>
        <D.SkeletonTag />
        <D.SkeletonTag />
      </D.SkeletonTagRow>
      <D.SkeletonLine $width={75} $height={20} />
      <D.SkeletonLine $width={55} $height={14} />
      <D.SkeletonLine $width={90} $height={12} />
      <D.SkeletonLine $width={70} $height={12} />
      <D.SkeletonLine $width={40} $height={36} />
    </D.SkeletonBody>
  </D.SkeletonCard>
);

export default FarmCardDesktopSkeleton;
